import {
  Box,
  Button,
  Flex,
  Grid,
  GridItem,
  Heading,
  Input,
  Select,
  Skeleton,
  Text,
  useToast,
  FormControl,
  FormLabel,
  Divider,
} from "@chakra-ui/react";
import BreadCrumbMaker from "../../components/BreadCrumbMaker";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";

const SERVER = import.meta.env.VITE_API_URL || "https://api.travelprym.in";

const PAYMENT_STATUSES = {
  PENDING: "Pending",
  PAID: "Paid",
  FAILED: "Failed",
};

const PAYMENT_METHODS = {
  CARD: "Card",
  UPI: "UPI",
  NET_BANKING: "NetBanking",
};

const handleSendToken = async () => {
  try {
    const token = localStorage.getItem("prima_session");
    if (!token) {
      toast({
        title: "Authentication Error",
        description: "Session token not found. Please login again.",
        status: "error",
        duration: 4000,
      });
      return;
    }

    if (!lead?.leadID) {
      toast({
        title: "Error",
        description: "Lead ID is missing.",
        status: "error",
        duration: 3000,
      });
      return;
    }

    if (!estimatedFare || estimatedFare <= 0) {
      toast({
        title: "Invalid Fare",
        description:
          "Please set a valid estimated fare before sending token request.",
        status: "error",
        duration: 3000,
      });
      return;
    }

    // Calculate token amount (15% of estimated fare)
    const tokenAmt = Math.round(estimatedFare * 0.15);
    if (tokenAmt < 1) {
      toast({
        title: "Invalid Token Amount",
        description: "Token amount must be at least ₹1.",
        status: "warning",
        duration: 3000,
      });
      return;
    }

    const payload = {
      amount: tokenAmt,
      userPhone: lead.customer?.mobile || "",
      userEmail: lead.customer?.email || "",
      orderId: lead.leadID,
      leadId: lead._id,
      customerId: lead.customer?._id || null,
    };

    setPaymentLoading(true);

    const res = await axios.post(`${SERVER}/payments/send-token`, payload, {
      headers: { Authorization: `Bearer ${token}` },
    });

    const paymentId =
      res.data?.paymentLinkId ||
      res.data?.data?._id ||
      res.data?.data?.paymentId ||
      res.data?._id;

    toast({
      title: "Token Request Sent!",
      description: "Payment link has been sent to customer.",
      status: "success",
      duration: 3000,
      isClosable: true,
    });

    // Refresh lead data to get updated payment info
    const leadRes = await axios.get(`${SERVER}/management/lead?id=${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    const updatedLead = leadRes.data.data;
    setLead(updatedLead);

    // Fetch the newly created payment
    if (paymentId) {
      try {
        const paymentRes = await axios.get(
          `${SERVER}/management/payment-by-lead/${lead.leadID}`,
          { headers: { Authorization: `Bearer ${token}` } },
        );
        if (paymentRes.data?.data) {
          const payment = paymentRes.data.data;
          setPaymentId(payment._id);
          setPaymentStatus(payment.status || "Pending");
          setTokenAmount(payment.amount || tokenAmt);
        }
      } catch (paymentErr) {
        console.log("Error fetching payment:", paymentErr);
      }
    }
  } catch (error) {
    console.error("Token Error:", error?.response?.data || error.message);
    const errorMessage =
      error?.response?.data?.message ||
      error?.response?.data?.error ||
      error.message ||
      "Unknown error occurred";
    toast({
      title: "Error Sending Token",
      description: `Request failed: ${errorMessage}`,
      status: "error",
      duration: 5000,
      isClosable: true,
    });
  } finally {
    setPaymentLoading(false);
  }
};
const EditPendingToken = () => {
  const { id } = useParams();
  const [payment, setPayment] = useState(null);
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();
  const toast = useToast();

  useEffect(() => {
    const fetchPayment = async () => {
      try {
        const token = localStorage.getItem("prima_session");
        if (!token) {
          toast({
            title: "Authentication required",
            status: "error",
            duration: 3000,
          });
          navigate("/bookings");
          return;
        }

        const res = await axios.get(
          `${SERVER}/management/pending-token/${id}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          },
        );

        setPayment(res.data.data);
      } catch (err) {
        console.error(err);
        toast({
          title: "Error loading payment",
          description:
            err.response?.data?.message || "Failed to load payment details",
          status: "error",
          duration: 3000,
        });
        navigate("/bookings");
      } finally {
        setLoading(false);
      }
    };

    fetchPayment();
  }, [id, navigate, toast]);

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   setSubmitting(true);

  //   try {
  //     const token = localStorage.getItem("prima_session");
  //     if (!token) {
  //       toast({
  //         title: "Authentication required",
  //         status: "error",
  //         duration: 3000,
  //       });
  //       return;
  //     }

  //     await axios.patch(
  //       `${SERVER}/management/pending-token/${id}`,
  //       {
  //         status: payment.status,
  //         amount: payment.amount,
  //         method: payment.method,
  //         transactionID: payment.transactionID,
  //         reference: payment.reference,
  //       },
  //       {
  //         headers: { Authorization: `Bearer ${token}` },
  //       },
  //     );

  //     toast({
  //       title: "Payment updated",
  //       description: "Payment details updated successfully",
  //       status: "success",
  //       duration: 3000,
  //     });

  //     // Convert lead to booking after payment is updated
  //     try {
  //       const leadID = payment.lead?.leadID || payment.orderId;
  //       if (leadID) {
  //         const conversionRes = await axios.post(
  //           `${SERVER}/management/lead-to-booking`,
  //           { leadId: leadID },
  //           { headers: { Authorization: `Bearer ${token}` } },
  //         );

  //         // Update the booking status to Unassigned
  //         const bookingID =
  //           conversionRes.data?.data?._id ||
  //           conversionRes.data?.data?.id ||
  //           conversionRes.data?.data?.bookingID;
  //         if (bookingID) {
  //           try {
  //             await axios.patch(
  //               `${SERVER}/management/booking/${bookingID}`,
  //               { status: "Unassigned" },
  //               { headers: { Authorization: `Bearer ${token}` } },
  //             );
  //           } catch (statusErr) {
  //             console.warn("Could not update booking status:", statusErr);
  //           }
  //         }

  //         toast({
  //           title: "Lead Converted",
  //           description:
  //             "Lead has been moved to Bookings with Unassigned status.",
  //           status: "success",
  //           duration: 3000,
  //         });
  //       }
  //     } catch (conversionErr) {
  //       console.error("Lead conversion error:", conversionErr);
  //       // Don't show error to user as payment was successfully updated
  //     }

  //     // Navigate to bookings list
  //     setTimeout(() => {
  //       navigate("/bookings?tab=Bookings");
  //     }, 1500);
  //   } catch (err) {
  //     console.error(err);
  //     toast({
  //       title: "Update failed",
  //       description: err.response?.data?.message || "Failed to update payment",
  //       status: "error",
  //       duration: 3000,
  //     });
  //   } finally {
  //     setSubmitting(false);
  //   }
  // };

  const handleMarkAsPaid = async () => {
    setSubmitting(true);

    try {
      const token = localStorage.getItem("prima_session");
      if (!token) {
        toast({
          title: "Authentication required",
          status: "error",
          duration: 3000,
        });
        return;
      }

      // Update payment status to Paid
      await axios.patch(
        `${SERVER}/management/pending-token/${id}`,
        {
          status: "Pending",
          amount: payment.amount,
          // method: payment.method,
          // transactionID: payment.transactionID,
          // reference: payment.reference,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      toast({
        title: "Token Amount Updated",
        description: "Token amount has been updated successfully",
        status: "success",
        duration: 3000,
      });

      // Convert lead to booking after payment is marked as paid
      // try {
      //   const leadID = payment.lead?.leadID || payment.orderId;
      //   if (leadID) {
      //     const conversionRes = await axios.post(
      //       `${SERVER}/management/lead-to-booking`,
      //       { leadId: leadID },
      //       { headers: { Authorization: `Bearer ${token}` } },
      //     );

      //     // Update the booking status to Unassigned
      //     const bookingID =
      //       conversionRes.data?.data?._id ||
      //       conversionRes.data?.data?.id ||
      //       conversionRes.data?.data?.bookingID;
      //     if (bookingID) {
      //       try {
      //         await axios.patch(
      //           `${SERVER}/management/booking/${bookingID}`,
      //           { status: "Unassigned" },
      //           { headers: { Authorization: `Bearer ${token}` } },
      //         );
      //       } catch (statusErr) {
      //         console.warn("Could not update booking status:", statusErr);
      //       }
      //     }

      //     toast({
      //       title: "Lead Converted",
      //       description:
      //         "Lead has been moved to Bookings with Unassigned status.",
      //       status: "success",
      //       duration: 3000,
      //     });
      //   }
      // } catch (conversionErr) {
      //   console.error("Lead conversion error:", conversionErr);
      //   // Don't show error to user as payment was successfully updated
      // }

      // Navigate to bookings list
      setTimeout(() => {
        navigate(`/booking/pending/${id}`);
      }, 1500);
    } catch (err) {
      console.error(err);
      toast({
        title: "Failed to update",
        description: err.response?.data?.message || "An error occurred",
        status: "error",
        duration: 3000,
      });
    } finally {
      setSubmitting(false);
    }
  };

  if (loading) {
    return (
      <Box p={6}>
        <Skeleton height="20px" width="200px" mb={6} />
        <Skeleton height="40px" width="300px" mb={6} />
        <Box bg="white" p={6} rounded="md" shadow="sm">
          <Grid templateColumns="repeat(2, 1fr)" gap={6}>
            {Array.from({ length: 10 }).map((_, i) => (
              <GridItem key={i}>
                <Skeleton height="20px" width="120px" mb={2} />
                <Skeleton height="40px" />
              </GridItem>
            ))}
          </Grid>
        </Box>
      </Box>
    );
  }

  if (!payment) {
    return (
      <Box p={6}>
        <Text>Payment not found</Text>
      </Box>
    );
  }

  return (
    <Box p={6}>
      <BreadCrumbMaker
        items={[
          { link: "/bookings", title: "Bookings" },
          { link: "#", title: "Edit Payment Token", on: true },
        ]}
      />

      <Heading size="lg" mb={6} mt={4}>
        Edit Payment Token
      </Heading>

      <Box bg="white" p={6} rounded="md" shadow="sm">
        <form 
        // onSubmit={handleSubmit}
        >
          <Grid templateColumns="repeat(2, 1fr)" gap={6}>
            {/* Read-only fields */}
            {/* <GridItem>
              <FormControl>
                <FormLabel>Payment ID</FormLabel>
                <Input value={payment.paymentID} isReadOnly bg="gray.50" />
              </FormControl>
            </GridItem> */}

            <GridItem>
              <FormControl>
                <FormLabel>Customer</FormLabel>
                <Input
                  value={payment.customer?.name || "-"}
                  isReadOnly
                  bg="gray.50"
                />
              </FormControl>
            </GridItem>

            <GridItem>
              <FormControl>
                <FormLabel>Mobile</FormLabel>
                <Input
                  value={payment.customer?.mobile || "-"}
                  isReadOnly
                  bg="gray.50"
                />
              </FormControl>
            </GridItem>

            <GridItem>
              <FormControl>
                <FormLabel>Type</FormLabel>
                <Input value={payment.type} isReadOnly bg="gray.50" />
              </FormControl>
            </GridItem>

            <Divider gridColumn="span 2" />

            {/* Editable fields */}
            <GridItem>
              <FormControl isRequired>
                <FormLabel>Amount (₹)</FormLabel>
                <Input
                  type="number"
                  value={payment.amount}
                  onChange={(e) =>
                    setPayment({ ...payment, amount: Number(e.target.value) })
                  }
                  min={0}
                  step={0.01}
                />
              </FormControl>
            </GridItem>

            {/* <GridItem>
              <FormControl isRequired>
                <FormLabel>Status</FormLabel>
                <Select
                  value={payment.status}
                  onChange={(e) =>
                    setPayment({ ...payment, status: e.target.value })
                  }
                >
                  {Object.values(PAYMENT_STATUSES).map((status) => (
                    <option key={status} value={status}>
                      {status}
                    </option>
                  ))}
                </Select>
              </FormControl>
            </GridItem> */}

            {/* <GridItem>
              <FormControl>
                <FormLabel>Payment Method</FormLabel>
                <Select
                  value={payment.method || ""}
                  onChange={(e) =>
                    setPayment({ ...payment, method: e.target.value })
                  }
                >
                  <option value="">Select method</option>
                  {Object.values(PAYMENT_METHODS).map((method) => (
                    <option key={method} value={method}>
                      {method}
                    </option>
                  ))}
                </Select>
              </FormControl>
            </GridItem> */}

            {/* <GridItem>
              <FormControl>
                <FormLabel>Transaction ID</FormLabel>
                <Input
                  value={payment.transactionID || ""}
                  onChange={(e) =>
                    setPayment({ ...payment, transactionID: e.target.value })
                  }
                  placeholder="Enter transaction ID"
                />
              </FormControl>
            </GridItem> */}

            {/* <GridItem colSpan={2}>
              <FormControl>
                <FormLabel>Reference</FormLabel>
                <Input
                  value={payment.reference || ""}
                  onChange={(e) =>
                    setPayment({ ...payment, reference: e.target.value })
                  }
                  placeholder="Enter reference"
                />
              </FormControl>
            </GridItem> */}
          </Grid>

          <Flex mt={8} gap={4}>
            {/* <Button
              type="submit"
              colorScheme="blue"
              isLoading={submitting}
              loadingText="Updating..."
            >
              Update Payment
            </Button> */}
            <Button
              colorScheme="green"
              onClick={handleMarkAsPaid}
              isLoading={submitting}
              loadingText="Processing..."
            >
              Update Token Amount
            </Button>
            <Button
              variant="outline"
              onClick={() => navigate("/bookings")}
              isDisabled={submitting}
            >
              Cancel
            </Button>
          </Flex>
        </form>
      </Box>
    </Box>
  );
};

export default EditPendingToken;
